import { LocaleKey } from 'helpers/languages/translations';

export const USER_FIELDS = [
    'id',
    'username',
    'first_name',
    'last_name',
    'email',
    'language',
    'international_company',
    'company',
    'company_group',
    'international_company_group',
    'allowed_tools',
    'allowed_competitors',
    'allowed_tabs',
    'allowed_retailers',
    'allowed_blocks',
    'allowed_categories_clients',
    'commercial_id',
    'regions',
    'sectors',
    'has_notification_pdf_active',
    'user_permissions',
    'groups',
    'is_active',
    'is_staff',
    'is_superuser',
];

export const DISABLED_FIELDS = ['international_company_group'];

export const INTERNATIONAL_USERS_FIELDS = [
    'id',
    'username',
    'first_name',
    'last_name',
    'commercial_id',
    'company_group',
    'company_name',
    'international_company',
    'has_notification_pdf_active',
    'user_permissions',
    'language',
    'is_active',
    'is_staff',
    'groups',
    'is_superuser',
];

export const USER_FORM_SKIPPED_FIELD = [
    'id',
    'email',
    'allowed_retailers',
    'allowed_tools',
    'allowed_competitors',
    'allowed_tabs',
    'allowed_blocks',
    'allowed_categories_clients',
    'regions',
    'sectors',
    'has_notification_pdf_active',
    'user_permissions',
    'is_staff',
    'is_superuser',
];

export const COMPANY_FORM_SKIPPED_FIELD = {
    id: 'id',
    email: 'email',
    allowed_retailers: 'allowed_retailers',
    company: 'company',
    allowed_tools: 'allowed_tools',
    allowed_competitors: 'allowed_competitors',
    allowed_tabs: 'allowed_tabs',
    allowed_blocks: 'allowed_blocks',
    allowed_categories_clients: 'allowed_categories_clients',
    regions: 'regions',
    sectors: 'sectors',
    has_notification_pdf_active: 'has_notification_pdf_active',
    user_permissions: 'user_permissions',
    is_staff: 'is_staff',
    is_superuser: 'is_superuser',
    is_active: 'is_active',
};

export const PREFERED_COLUMN_ORDER: string[] = ['username', 'first_name', 'last_name', 'email'];

export const PREFERED_CG_COLUMN_ORDER: string[] = ['name', 'tools', 'is_default'];

export const HIDDEN_COLUMN: string[] = [
    'id',
    'email',
    'company',
    'allowed_tools',
    'allowed_competitors',
    'allowed_tabs',
    'allowed_retailers',
    'allowed_blocks',
    'allowed_categories_clients',
    'regions',
    'sectors',
    'has_notification_pdf_active',
    'user_permissions',
    'is_staff',
    'is_superuser',
];
export const COMPANY_HIDDEN_COLUMN: string[] = ['id'];

export const COMPANY_FIELDS = ['id', 'name', 'tools', 'is_default', 'users'];
export const COMPANY_FIELDS_FROM = [
    'id',
    'name',
    'is_custom_cg_sync_with_tools',
    'tools',
    'retailers',
    'categories_clients',
];

export const HEADER_COMPANY = {
    name: 'cg.name' as LocaleKey,
    tools: 'cg.tools' as LocaleKey,
    retailers: 'cg.retailers' as LocaleKey,
    categories_clients: 'cg.categories_clients' as LocaleKey,
    is_custom_cg_sync_with_tools: 'cg.is_custom_cg_sync_with_tools' as LocaleKey,
    is_default: 'cg.is_default' as LocaleKey,
    users: 'cg.users' as LocaleKey,
};

export const SELECT_LANGUAGES = [
    { name: 'FR', id: 'fr' },
    { name: 'EN', id: 'en' },
];

export const HEADER_USER = {
    username: 'users.email' as LocaleKey,
    first_name: 'users.first_name' as LocaleKey,
    last_name: 'users.last_name' as LocaleKey,
    international_company: 'users.international_company' as LocaleKey,
    language: 'users.language' as LocaleKey,
    company: 'users.company' as LocaleKey,
    commercial_id: 'users.commercial_id' as LocaleKey,
    company_group: 'users.company_group' as LocaleKey,
    international_company_group: 'users.international_company_group' as LocaleKey,
    groups: 'users.user_roles' as LocaleKey,
    is_active: 'users.is_active' as LocaleKey,
    has_notification_pdf_active: 'users.email' as LocaleKey,
    is_staff: 'users.email' as LocaleKey,
    is_superuser: 'users.email' as LocaleKey,
};

export const HEADER_INTERNATIONAL_USER = {
    username: 'users.username' as LocaleKey,
    first_name: 'users.first_name' as LocaleKey,
    last_name: 'users.last_name' as LocaleKey,
    international_company: 'users.international_company' as LocaleKey,
    language: 'users.language' as LocaleKey,
    company: 'users.company' as LocaleKey,
    company_name: 'users.company_name' as LocaleKey,
    commercial_id: 'users.commercial_id' as LocaleKey,
    company_group: 'users.company_group' as LocaleKey,
    groups: 'users.user_roles' as LocaleKey,
    is_active: 'users.is_active' as LocaleKey,
    has_notification_pdf_active: 'users.email' as LocaleKey,
    is_staff: 'users.email' as LocaleKey,
    is_superuser: 'users.email' as LocaleKey,
};

export const DEFAULT_USER_GROUP = { id: 4, name: 'USER', typePeriod: 0 };

export const DEFAULT_USER = {
    id: 0,
    name: '',
    company_id: 0,
    tools: [],
    tabs: [],
    retailers: [],
    is_default: false,
    categories_clients: [],
    is_custom_cg_sync_with_tools: true,
    sync_with_tools: true,
};

export type THEADER_COMPANY = keyof typeof HEADER_COMPANY;
export type TUSER_FORM_SKIPPED_FIELD = keyof typeof USER_FORM_SKIPPED_FIELD;
export type THEADER_USER = keyof typeof HEADER_USER;
export type THEADER_INTERNATIONAL_USER = keyof typeof HEADER_INTERNATIONAL_USER;
